<template>
  <header :class="activeName == '首页' || newStyle ? 'app-header' : 'new-app-header'">
    <div class="container">
      <div class="tabs-list">
        <div class="tabs-item" v-for="(item, i) in tabList" :key="i" :class="activeName == item.label ? 'active' : ''"
          @click="handleClick(item)">{{ item.label }}</div>
      </div>
      <!-- 搜索 -->
      <div class="search" v-if="isSearch" @click="onSearch">
        <input type="text" placeholder="请输入内容">
        <i class="iconfont icon-search"></i>
      </div>
    </div>
  </header>
</template>

<script setup>
import { watch, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
// $router.push('/search')
const activeName = ref('首页')

const router = useRouter()
const route = useRoute()
const newStyle = ref(false)

const isSearch = ref(true)
const tabList = ref([
  {
    label: '首页',
    url: '/'
  },
  {
    label: '交易大厅',
    url: '/trading-floor'
  },
  {
    label: '公示公告',
    url: '/public-announcement'
  },
  {
    label: '数据分析',
    url: '/data-analysis'
  },
  {
    label: '政策法规',
    url: '/policies-regulations?type=policies'
  },
  {
    label: '资料下载',
    url: '/policies-regulations?type=down'
  },
  {
    label: '服务中心',
    url: '/service-center'
  },
])

watch(
  () => route.path,
  (newVal) => {
    newStyle.value = newVal == '/'
    activeName.value = ''
    isSearch.value = true
    switch (newVal) {
      case '/':
        activeName.value = '首页'
        break;
      case '/trading-floor':
        activeName.value = '交易大厅'
        break;
      case '/public-announcement':
        activeName.value = '公示公告'
        break;
      case '/service-center':
        activeName.value = '服务中心'
        break;
      case '/data-analysis':
        activeName.value = '数据分析'
        break;
      case '/policies-regulations':
        if (route.query.type == 'policies') {
          activeName.value = '政策法规'
        } else {
          activeName.value = '资料下载'
        }
        break;
      case '/search':
        isSearch.value = false
        break;
    }
  },
  { immediate: true }
)

const handleClick = (val) => {
  router.push(val.url)
  activeName.value = val.label
  isSearch.value = true
}


const onSearch = () => {
  router.push('/search')
  isSearch.value = false
}
</script>

<style scoped lang='less'>
.app-header {
  position: absolute;
  top: 6.25rem;
  left: 0;
  width: 100%;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 85rem;

    .tabs-list {
      height: 5rem;
      display: flex;

      .tabs-item {
        height: 100%;
        color: #fff;
        font-size: 1.125rem;
        padding: 0 2.262rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
      }

      .active::before {
        content: '';
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 80%;
        height: 3px;
        translate: -50%;

      }
    }
  }

  .logo {
    width: 200px;

    a {
      display: block;
      height: 132px;
      width: 100%;
      text-indent: -9999px; //隐藏网站名字，写网站名为了SEO
      // background: url(../assets/images/logo.png) no-repeat center 18px / contain;
      background: url(../assets/images/logo.png) no-repeat center -30px;
      background-size: 320px 220px;
    }
  }

  .search {
    width: 13.75rem;
    height: 2rem;
    border: 1px solid #fff;
    border-radius: 3.125rem;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;

    .icon-search {
      font-size: 0.813rem;
      color: #fff;
    }

    input {
      width: 9.2rem;
      padding-left: 5px;
      color: #C0C4CC;
      background: transparent;
    }
  }

  .cart {
    width: 50px;

    .curr {
      height: 32px;
      line-height: 32px;
      text-align: center;
      position: relative;
      display: block;

      .icon-cart {
        font-size: 22px;
      }

      em {
        font-style: normal;
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px 6px;
        line-height: 1;
        background: @helpColor;
        color: #fff;
        font-size: 12px;
        border-radius: 10px;
        font-family: Arial;
      }
    }
  }
}

.new-app-header {
  width: 100%;
  background: #000;
  background-image: url(../assets/images/head/head.png);
  background-size: 100% 100%;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 85rem;

    .tabs-list {
      height: 5rem;
      display: flex;

      .tabs-item {
        height: 100%;
        color: #fff;
        font-size: 1.125rem;
        padding: 0 2.262rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
      }

      .active::before {
        content: '';
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 80%;
        height: 3px;
        translate: -50%;

      }
    }
  }

  .logo {
    width: 200px;

    a {
      display: block;
      height: 132px;
      width: 100%;
      text-indent: -9999px; //隐藏网站名字，写网站名为了SEO
      // background: url(../assets/images/logo.png) no-repeat center 18px / contain;
      background: url(../assets/images/logo.png) no-repeat center -30px;
      background-size: 320px 220px;
    }
  }

  .search {
    width: 13.75rem;
    height: 2rem;
    border: 1px solid #fff;
    border-radius: 3.125rem;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;

    .icon-search {
      font-size: 0.813rem;
      color: #fff;
    }

    input {
      width: 9.2rem;
      padding-left: 5px;
      color: #C0C4CC;
      background: transparent;
    }
  }

  .cart {
    width: 50px;

    .curr {
      height: 32px;
      line-height: 32px;
      text-align: center;
      position: relative;
      display: block;

      .icon-cart {
        font-size: 22px;
      }

      em {
        font-style: normal;
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px 6px;
        line-height: 1;
        background: @helpColor;
        color: #fff;
        font-size: 12px;
        border-radius: 10px;
        font-family: Arial;
      }
    }
  }

}
</style>
